import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useControleMateriaisListaViewModel } from "../../viewModels/controle_materiais_lista_view_model";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateControleColumnDefinition } from "./columns";
import { GetAllControleMateriaisDao } from "../../../data/daos/read/get_all_controle_materiais";
import { ModalControleMateriais } from "./components/modal_create";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const ControleMateriaisLista = () => {
  const viewModel = useControleMateriaisListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControleColumnDefinition({
      onActionEditar: viewModel.handleEditControleMateriaisOpenState,
      onActionDeletar: viewModel.DeleteOpenModal,
      onActionDownload: viewModel.handleDownload,
    });
  }, [
    viewModel.handleEditControleMateriaisOpenState,
    viewModel.DeleteOpenModal,
    viewModel.handleDownload,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
                <PrimaryButton buttonColor="yellow" onClick={viewModel.handleGerarRelatorio}>
                  Gerar relatório
                </PrimaryButton>
              </div>

              <div className="w-[10rem] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={(e) => {
                    if (e.button === 1) {
                      viewModel.abrirModalCreate();
                    } else {
                      viewModel.abrirModalCreate();
                    }
                    e.preventDefault();
                  }}
                >
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Typography className="text-primary-green">Materiais Controlados</Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Lista de Materiais Controlados </h1>
            <RefreshButton onClick={() => { }} />
          </div>

          <div className="w-full justify-end flex gap-2">
            <div className=""></div>
          </div>
        </div>

        <Header
          Status={viewModel.filters.status}
          numero={viewModel.filters.numero}
          descricao={viewModel.filters.descricao}
          onStatusChange={viewModel.handleStatusChange}
          onNumeroChange={viewModel.handleNumeroChange}
          onDescricaoChange={viewModel.handleDescricaoChange}
          onClear={viewModel.handleClear}
        />

        <Stack spacing={0}>
          <div className="w-full flex flex-row justify-between items-stretch">
            <div className="flex flex-col justify-between flex-1">
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
              />
            </div>
          </div>

          <StyledDataGrid
            tableName="MateriaisControlados"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: GetAllControleMateriaisDao) => row.idMateriaisControlados ?? ""}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.controleMateriais}
            rowCount={viewModel.controleMateriais.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["idMateriaisControlados"],
            }}
          />

          <div className="flex flex-col justify-between flex-1">
            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </div>
        </Stack>
      </div>

      <ModalControleMateriais
        open={viewModel.abrirModal}
        saving={viewModel.saving}
        onClose={() => viewModel.fecharmodal()}
        onSubmit={viewModel.handleDocumentoSubmit}
        dados={viewModel.dadosEdit}
        editmod={viewModel.editmod}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.DeleteOpenModal(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarMateriaisControlados}
      />
    </>
  );
};
